class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };

    this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  onItemClick(event) {
    const element = event.currentTarget !== null ? event.currentTarget : event.target;
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = element.dataset.value;
    if (form) form.submit();
  }

  setCookie() {
    setTimeout(() => {
      sessionStorage.setItem('localization_checked', true);
    }, 500);
  }

  async checkLocation() {
    fetch(Shopify.routes.root + 'browsing_context_suggestions.json?country[enabled]=true') // To enable language suggestions, add &language[enabled]=true
      .then((response) => response.json())
      .then((json) => {
        json.suggestions?.forEach((suggestion) => {
          const suggestedCountryCode = suggestion.parts?.country?.handle;

          // Skip if the suggested country is not available
          if (!suggestedCountryCode) return;

          // Skip if the suggested country is the same as the current country
          if (Shopify?.country === suggestedCountryCode) return;

          // Update the suggestion element with the suggested country details
          const suggestedCountryElements = document.querySelectorAll('.localization__label--suggestion');
          suggestedCountryElements.forEach((suggestedCountryElement) => {
            const suggestedCountryName = suggestion.parts?.country?.name || false;
            if (suggestedCountryName) {
              suggestedCountryElement.innerHTML = suggestedCountryElement.innerHTML.replaceAll('{countryCode}', suggestedCountryCode.toLowerCase()).replaceAll('{countryName}', suggestedCountryName);
              suggestedCountryElement.classList.remove('hidden');
            }
          });

          // Open the localization panel to show the suggestion
          if (window.innerWidth >= 1024 && this.closest('.announcement-bar')) {
            this.elements?.button?.click();
          } else if (window.innerWidth < 1024 && this.closest('header')) {
            const menuButton = document.querySelector('toggle-mobile-navigation');
            if (menuButton) {
              this.elements?.button?.click();
              if (!menuButton.hasAttribute('aria-expanded') || menuButton.getAttribute('aria-expanded') === 'false') menuButton.click();
            }
          }

          // Set a session storage flag to avoid re-checking during the same session
          this.setCookie();
        });
      })
      .catch((error) => {
        console.warn(error);
      });
  }

  connectedCallback() {
    // Check location only if not already checked in this session
    if (!sessionStorage.getItem('localization_checked')) {
      this.checkLocation();
    }
  }
}
if (!customElements.get('localization-form')) {
  customElements.define('localization-form', LocalizationForm);
}
